import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

class SubscriptionConfigurator extends HTMLElement {
    connectedCallback() {
        this.data = JSON.parse(this.querySelector("[data-configurator-products]").textContent);
        console.log(this.data);

        this.modelCards = JSON.parse(this.querySelector("[data-model-cards]")?.textContent || "{}");

        /* Le filtre Liquid `t` échappe les caractères HTML (ex: ' -> &#39;), on décode les traductions */
        const decodeEntities = (value) => {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = value;
            return textarea.value;
        };
        this.i18n = Object.fromEntries(
            Object.entries(JSON.parse(this.querySelector("[data-configurator-i18n]").textContent)).map(
                ([key, value]) => [key, decodeEntities(value)],
            ),
        );

        this.state = {
            type: null,
            typeLabel: null,
            product: null,
            variant: null,
            frequency: null,
            crossSell: [],
        };

        this.maxCrossSellProducts = 5;

        this.steps = {};
        this.querySelectorAll("[data-step]").forEach((step) => {
            this.steps[step.getAttribute("data-step")] = step;
        });

        this.modelGrid = this.querySelector("[data-model-grid]");
        this.sizeGrid = this.querySelector("[data-size-grid]");
        this.sizeInfo = this.querySelector("[data-size-info]");
        this.frequencyList = this.querySelector("[data-frequency-list]");
        this.subscribeButton = this.querySelector("[data-subscribe]");

        this.addEventListener("click", this.handleClick.bind(this));

        this.initSliders();
        this.setupCrossSellTabs();
        this.renderTypePrices();

        /* Pré-sélection par défaut : premier type -> premier modèle -> première taille -> fréquence recommandée */
        const firstType = this.querySelector("[data-type-choice]");
        if (firstType) this.selectType(firstType, true);
    }

    /* ============================================================ */
    /* Prix affichés sur les cartes type (couche / culotte)         */
    /* ============================================================ */
    renderTypePrices() {
        this.querySelectorAll("[data-type-choice]").forEach((card) => {
            const products = this.data[card.getAttribute("data-type")] || [];
            const variants = products.flatMap((product) => product.variants || []);
            if (!variants.length) return;

            const price = Math.min(...variants.map((variant) => variant.price));
            const comparePrices = variants.map((variant) => variant.compare_price).filter((value) => value > 0);

            card.querySelector("[data-type-price-value]").textContent = this.formatMoney(price);

            if (comparePrices.length) {
                const comparePrice = Math.min(...comparePrices);
                if (comparePrice > price) {
                    const priceCompare = card.querySelector("[data-type-price-compare]");
                    priceCompare.textContent = this.formatMoney(comparePrice);
                    priceCompare.classList.remove("hidden");
                }
            }

            card.querySelector("[data-type-price]").classList.remove("hidden");
        });
    }

    /* ============================================================ */
    /* Délégation des clics                                         */
    /* ============================================================ */
    handleClick(event) {
        const typeChoice = event.target.closest("[data-type-choice]");
        if (typeChoice) return this.selectType(typeChoice);

        const modelChoice = event.target.closest("[data-model-choice]");
        if (modelChoice) return this.selectModel(modelChoice);

        const sizeChoice = event.target.closest("[data-size-choice]");
        if (sizeChoice) return this.selectSize(sizeChoice);

        const frequencyToggle = event.target.closest("[data-frequency-toggle]");
        if (frequencyToggle) return this.toggleFrequencyOptions();

        const frequencyChoice = event.target.closest("[data-frequency-choice]");
        if (frequencyChoice) return this.selectFrequency(frequencyChoice.getAttribute("data-name"));

        const crossSellTab = event.target.closest("[data-cross-sell-tab]");
        if (crossSellTab) return this.selectCrossSellTab(crossSellTab);

        const crossSellProduct = event.target.closest("[data-cross-sell-product]");
        if (crossSellProduct) return this.toggleCrossSellProduct(crossSellProduct);

        const openDrawer = event.target.closest("[data-open-drawer]");
        if (openDrawer) {
            document.getElementById(openDrawer.getAttribute("data-open-drawer"))?.classList.add("opened");
            document.body.style.overflow = "hidden";
            return;
        }

        const closeDrawer = event.target.closest("[data-close-drawer]");
        if (closeDrawer) {
            document.getElementById(closeDrawer.getAttribute("data-close-drawer"))?.classList.remove("opened");
            document.body.style.overflow = "";
            return;
        }

        const subscribe = event.target.closest("[data-subscribe]");
        if (subscribe) return this.subscribe();
    }

    /* ============================================================ */
    /* Étape : type d'abonnement                                    */
    /* ============================================================ */
    selectType(card, silent = false) {
        this.setActiveCard("[data-type-choice]", card);

        this.state.type = card.getAttribute("data-type");
        this.state.typeLabel = card.getAttribute("data-title") || "";
        this.updateModelHelpDrawer();
        this.resetFrom("model");

        const products = this.data[this.state.type] || [];
        let scrollTarget = "model";

        if (products.length === 1) {
            /* Un seul produit (couches-culottes) : on saute l'étape modèle */
            this.steps.model.classList.add("hidden");
            this.state.product = products[0];
            this.renderSizes();
            this.setLocked("size", false);
            this.autoSelectFirstSize();
            scrollTarget = "size";
        } else {
            this.steps.model.classList.remove("hidden");
            this.renderModels(products);

            const firstModel = this.modelGrid.querySelector("[data-model-choice]");
            if (firstModel) this.selectModel(firstModel, true);
        }

        if (!silent) this.scrollToStep(scrollTarget);
    }

    /* ============================================================ */
    /* Étape : modèle                                               */
    /* ============================================================ */
    renderModels(products) {
        const cardSettings = this.modelCards[this.state.type] || [];

        this.modelGrid.innerHTML = products
            .map((product, index) => {
                console.log(product);

                const [parsedTitle, parsedSubtitle] = (product.title_slide || product.title).split("|");
                const settings = cardSettings[index] || {};
                const title = settings.title || parsedTitle || "";
                const subtitle = settings.subtitle || parsedSubtitle || "";

                return `
                    <button type="button" class="sc-card sc-model-card" data-model-choice data-product-id="${product.id}">
                        <img src="${this.escape(product.image)}" class="sc-model-card__image" loading="lazy" alt="${this.escape(product.title)}">
                        <span class="sc-card__label font-rooney">${this.escape(title.trim())}</span>
                        <span class="sc-model-card__subtitle">${this.escape(subtitle.trim())}</span>
                    </button>
                `;
            })
            .join("");
    }

    updateModelHelpDrawer() {
        this.querySelectorAll("[data-model-help-item]").forEach((item) => {
            item.classList.toggle("hidden", item.getAttribute("data-type") !== this.state.type);
        });
    }

    selectModel(card, silent = false) {
        this.setActiveCard("[data-model-choice]", card);

        const productId = parseInt(card.getAttribute("data-product-id"));
        this.state.product = (this.data[this.state.type] || []).find((product) => product.id === productId);
        this.resetFrom("size");

        this.renderSizes();
        this.setLocked("size", false);
        this.autoSelectFirstSize();

        if (!silent) this.scrollToStep("size");
    }

    autoSelectFirstSize() {
        const firstSize = this.sizeGrid.querySelector("[data-size-choice]");
        if (firstSize) this.selectSize(firstSize, true);
    }

    /* ============================================================ */
    /* Étape : taille                                               */
    /* ============================================================ */
    renderSizes() {
        this.colorPaletteCouche = [
            "#E85295",
            "#DD5596",
            "#4AA42F",
            "#E18531",
            "#BF2A28",
            "#5C267C",
            "#2D6AAC",
            "#3F8D75",
        ];

        /* Correspondance fixe : taille → index dans la palette */
        this.sizeColorMap = {
            1: 0,
            "1 à 2": 1,
            2: 2,
            3: 3,
            4: 4,
            "4+": 5,
            5: 6,
            6: 7,
        };

        this.sizeGrid.innerHTML = this.state.product.variants
            .map((variant, index) => {
                const rawSize = variant.title.split("(")[0].trim();
                const sizeLabel = /^\d/.test(rawSize) ? this.i18n.size_label.replace("%size%", rawSize) : rawSize;

                const weightMatch = variant.title.match(/\(([^)]+)\)/);
                const weight = weightMatch ? weightMatch[1].trim() : "";

                const rechargeParts = (this.state.product.prix_recharge[index]?.value || "")
                    .split("//")
                    .map((part) => part.trim());
                const countMatch = rechargeParts[0] ? rechargeParts[0].match(/\d+/) : null;
                const count = countMatch ? parseInt(countMatch[0]) : 0;
                const unitLabel = rechargeParts[1] && rechargeParts[2] ? `${rechargeParts[1]}/${rechargeParts[2]}` : "";

                /* Recherche dans la map, avec une couleur de secours si taille inconnue */
                const colorIndex = this.sizeColorMap[rawSize];
                const color =
                    colorIndex !== undefined
                        ? this.colorPaletteCouche[colorIndex]
                        : this.colorPaletteCouche[index % this.colorPaletteCouche.length];

                return `
            <button type="button" class="sc-card sc-size-card" data-size-choice data-variant-id="${variant.id}" data-size="${this.escape(sizeLabel)}" data-count="${count}" data-count-label="${this.escape(rechargeParts[0] || "")}" data-unit-label="${this.escape(unitLabel)}" style="--sc-size-color: ${color}; border-color: var(--sc-size-color);">
                <span class="sc-size-card__label font-rooney">${this.escape(sizeLabel)}</span>
                ${weight ? `<span class="sc-size-card__weight">${this.escape(weight)}</span>` : ""}
            </button>
        `;
            })
            .join("");
    }

    selectSize(card, silent = false) {
        this.setActiveCard("[data-size-choice]", card);

        const variantId = parseInt(card.getAttribute("data-variant-id"));
        this.state.variant = this.state.product.variants.find((variant) => variant.id === variantId);
        this.state.sizeLabel = card.getAttribute("data-size");
        this.state.count = parseInt(card.getAttribute("data-count")) || 0;
        this.state.countLabel = card.getAttribute("data-count-label");
        this.state.unitLabel = card.getAttribute("data-unit-label");

        this.renderSizeInfo();
        this.renderFrequencies();
        this.setLocked("frequency", false);
        this.setLocked("cross-sell", false);
        this.setLocked("recap", false);
        this.updateRecap();

        if (!silent) this.scrollToStep("frequency");
    }

    renderSizeInfo() {
        const countElement = this.sizeInfo.querySelector("[data-size-count]");
        const unitPriceElement = this.sizeInfo.querySelector("[data-size-unit-price]");
        const countText = countElement.querySelector("[data-size-count-text]");
        const unitPriceText = unitPriceElement.querySelector("[data-size-unit-price-text]");

        countText.textContent = this.state.countLabel || `${this.state.count} ${this.i18n.diapers}`;

        if (this.state.unitLabel) {
            /* Prix unitaire renseigné par le marchand dans le metafield recharge */
            unitPriceText.textContent = this.state.unitLabel;
            unitPriceElement.classList.remove("hidden");
        } else if (this.state.count > 0) {
            const unitPrice = this.formatMoney(this.state.variant.price / this.state.count);
            unitPriceText.textContent = `${unitPrice}/${this.i18n.per_unit}`;
            unitPriceElement.classList.remove("hidden");
        } else {
            unitPriceElement.classList.add("hidden");
        }

        this.sizeInfo.classList.remove("hidden");
        this.sizeInfo.classList.add("flex");
    }

    /* ============================================================ */
    /* Étape : fréquence                                            */
    /* ============================================================ */
    renderFrequencies() {
        const groups = this.state.variant.selling_plan_groups;
        const defaultIndex =
            this.state.product.default_frequency !== null ? Number(this.state.product.default_frequency) - 1 : 0;
        const defaultGroup = groups[defaultIndex] || groups[0];

        this.frequencyList.innerHTML = `
            <div class="sc-frequency">
                <button type="button" class="sc-frequency__toggle" data-frequency-toggle>
                    <span class="sc-frequency__current">
                        <span class="sc-frequency__label" data-frequency-current></span>
                        <span class="sc-frequency__per-day" data-frequency-per-day></span>
                    </span>
                    <span class="sc-frequency__meta">
                        <span class="sc-frequency__badge" data-frequency-badge>${this.escape(this.i18n.recommended)}</span>
                        <svg class="sc-frequency__chevron" width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="#11545F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </span>
                </button>
                <div class="sc-frequency__options hidden" data-frequency-options>
                    ${groups
                        .map(
                            (group, index) => `
                                <button type="button" class="sc-frequency__option" data-frequency-choice data-name="${this.escape(group.name)}">
                                    <span class="sc-frequency__option-label">${this.escape(this.frequencyLabel(group.name))} <span class="sc-frequency__per-day">${this.escape(this.perDayLabel(group.name))}</span></span>
                                    ${index === defaultIndex ? `<span class="sc-frequency__option-badge">${this.escape(this.i18n.recommended)}</span>` : ""}
                                </button>
                            `,
                        )
                        .join("")}
                </div>
            </div>
        `;

        this.selectFrequency(defaultGroup.name);
    }

    selectFrequency(name) {
        this.state.frequency = name;

        const groups = this.state.variant.selling_plan_groups;
        const defaultIndex =
            this.state.product.default_frequency !== null ? Number(this.state.product.default_frequency) - 1 : 0;
        const isRecommended = groups[defaultIndex] && groups[defaultIndex].name === name;

        this.frequencyList.querySelector("[data-frequency-current]").textContent = this.frequencyLabel(name);
        this.frequencyList.querySelector("[data-frequency-per-day]").textContent = this.perDayLabel(name);
        this.frequencyList.querySelector("[data-frequency-badge]").classList.toggle("hidden", !isRecommended);

        const options = this.frequencyList.querySelector("[data-frequency-options]");
        options.classList.add("hidden");
        options.classList.remove("flex");
        this.frequencyList.querySelector(".sc-frequency__chevron").classList.remove("rotate-180");

        this.updateRecap();
    }

    toggleFrequencyOptions() {
        const options = this.frequencyList.querySelector("[data-frequency-options]");
        options.classList.toggle("hidden");
        options.classList.toggle("flex");
        this.frequencyList.querySelector(".sc-frequency__chevron").classList.toggle("rotate-180");
    }

    frequencyLabel(name) {
        return this.i18n.frequency_label.replace("%frequency%", name.replace("semaines", this.i18n.weeks));
    }

    perDayLabel(name) {
        const weeksMatch = name.match(/\d+/);
        if (!weeksMatch || !this.state.count) return "";

        const perDay = Math.floor(this.state.count / (parseInt(weeksMatch[0]) * 7));
        return `(${this.i18n.diapers_per_day.replace("X", perDay)})`;
    }

    /* ============================================================ */
    /* Étape : cross-sell                                           */
    /* ============================================================ */
    setupCrossSellTabs() {
        const tabsContainer = this.querySelector("[data-cross-sell-tabs]");
        const navContainer = this.querySelector("[data-cross-sell-nav-container]");
        if (!tabsContainer) return;

        this.querySelectorAll(".sc-cross-sell__group").forEach((group) => {
            const tab = group.querySelector("[data-cross-sell-tab]");
            if (tab) tabsContainer.appendChild(tab);

            const nav = group.querySelector("[data-cross-sell-nav]");
            if (nav && navContainer) navContainer.appendChild(nav);
        });

        const firstTab = tabsContainer.querySelector("[data-cross-sell-tab]");
        if (firstTab) this.selectCrossSellTab(firstTab);
    }

    selectCrossSellTab(tab) {
        if (tab.classList.contains("active")) return;

        this.querySelectorAll("[data-cross-sell-tab]").forEach((otherTab) => otherTab.classList.remove("active"));
        tab.classList.add("active");

        const id = tab.getAttribute("data-cross-sell-tab");
        this.querySelectorAll(".more-product__container").forEach((container) => {
            const visible = container.id === id;
            container.classList.toggle("hidden", !visible);
            container.classList.toggle("block", visible);
        });

        this.querySelectorAll("[data-cross-sell-nav]").forEach((nav) => {
            nav.classList.toggle("hidden", nav.getAttribute("data-cross-sell-nav") !== id);
        });

        this.sliders?.forEach((slider) => slider.update());
    }

    toggleCrossSellProduct(card) {
        const variantId = card.getAttribute("data-variant-id");
        const label = card.querySelector(".text-product-more");

        if (card.classList.contains("active")) {
            card.classList.remove("active");
            label.textContent = this.i18n.add_to_subscription;
            this.state.crossSell = this.state.crossSell.filter((item) => item.variantId !== variantId);
        } else {
            if (this.state.crossSell.length >= this.maxCrossSellProducts) return;

            card.classList.add("active");
            label.textContent = this.i18n.added_to_subscription;
            this.state.crossSell.push({
                variantId: variantId,
                title: card.getAttribute("data-title"),
                sellingPlans: JSON.parse(card.getAttribute("data-selling-plans") || "{}"),
                price: parseInt(card.getAttribute("data-price")) || 0,
                comparePrice: parseInt(card.getAttribute("data-compare-price")) || 0,
            });
        }

        this.updateRecap();
    }

    /* ============================================================ */
    /* Étape : récapitulatif                                        */
    /* ============================================================ */
    updateRecap() {
        if (!this.state.variant) return;

        const title = this.i18n.recap_title
            .replace("%title%", (this.state.typeLabel || "").toLowerCase())
            .replace("%size%", this.state.sizeLabel || "");
        this.steps.recap.querySelector("[data-recap-title]").textContent = title;

        const countChip = this.steps.recap.querySelector("[data-recap-count]");
        countChip.querySelector("[data-recap-count-text]").textContent =
            this.state.countLabel || `${this.state.count} ${this.i18n.diapers}`;
        countChip.querySelectorAll("[data-recap-count-icon]").forEach((icon) => {
            icon.classList.toggle("hidden", icon.getAttribute("data-recap-count-icon") !== this.state.type);
        });
        countChip.classList.remove("hidden");

        const frequencyChip = this.steps.recap.querySelector("[data-recap-frequency]");
        frequencyChip.querySelector("[data-recap-frequency-text]").textContent =
            `${this.i18n.delivered_every} ${this.state.frequency.replace("semaines", this.i18n.weeks)}`;
        frequencyChip.classList.remove("hidden");

        const crossSellList = this.steps.recap.querySelector("[data-recap-cross-sell]");
        const crossSellInfo = this.steps.recap.querySelector(".cross-sell-info");
        const crossSellCountLabel =
            this.state.crossSell.length > 1 ? this.i18n.cross_sell_count_other : this.i18n.cross_sell_count_one;
        crossSellList.textContent = crossSellCountLabel.replace("%count%", this.state.crossSell.length);
        crossSellInfo.classList.toggle("hidden", this.state.crossSell.length === 0);

        const crossSellPrice = this.state.crossSell.reduce((sum, item) => sum + item.price, 0);
        const crossSellComparePrice = this.state.crossSell.reduce(
            (sum, item) => sum + (item.comparePrice || item.price),
            0,
        );

        const totalPrice = this.state.variant.price + crossSellPrice;
        const totalComparePrice =
            (this.state.variant.compare_price || this.state.variant.price) + crossSellComparePrice;

        this.steps.recap.querySelector("[data-recap-price-value]").textContent = this.formatMoney(totalPrice);

        const priceCompare = this.steps.recap.querySelector("[data-recap-price-compare]");
        priceCompare.classList.toggle("hidden", totalComparePrice <= totalPrice);
        if (totalComparePrice > totalPrice) {
            priceCompare.textContent = this.formatMoney(totalComparePrice);
        }

        this.subscribeButton.disabled = false;
    }

    /* ============================================================ */
    /* Ajout au panier + redirection checkout                       */
    /* ============================================================ */
    async subscribe() {
        if (!this.state.variant || !this.state.frequency || this.subscribeButton.classList.contains("loading")) return;

        this.subscribeButton.classList.add("loading");

        const sellingPlan = this.state.variant.selling_plan_groups.find((group) => group.name === this.state.frequency);

        const mainProperties = { _is_subscription: true };
        if (this.state.product.tag_cross_sell) {
            mainProperties["_tag"] = this.state.product.tag_cross_sell;
        }

        const items = [
            {
                id: this.state.variant.id,
                selling_plan: sellingPlan ? sellingPlan.id : undefined,
                quantity: 1,
                properties: mainProperties,
            },
        ];

        if (this.state.crossSell.length > 0) {
            const deliveryDate = await this.getEstimatedDeliveryDate();
            const frequencyNumber = this.state.frequency.match(/\d+/)?.[0];

            this.state.crossSell.forEach((item) => {
                const crossSellPlan = item.sellingPlans[`${frequencyNumber}-semaines`];

                items.push({
                    id: item.variantId,
                    selling_plan: crossSellPlan,
                    quantity: 1,
                    properties: {
                        _Livraison: deliveryDate,
                        _is_subscription: "true",
                        _shipping_interval_frequency: "1",
                        _shipping_interval_unit_type: "Days",
                        _crosssell: "true",
                    },
                });
            });
        }

        try {
            const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: items }),
            });

            if (!response.ok) throw new Error(`cart/add.js ${response.status}`);

            window.location.href = window.Shopify.routes.root + "checkout";
        } catch (error) {
            this.subscribeButton.classList.remove("loading");
            console.error("Erreur ajout au panier :", error);
        }
    }

    async getEstimatedDeliveryDate() {
        try {
            const response = await fetch(
                "https://estimated.omegatheme.com/p/api/estimated/date?shop=love-and-green.myshopify.com&ruleId=359914",
                {
                    method: "GET",
                    headers: {
                        authorization:
                            "pk_edd-6c6f76652d616e642d677265656e2e6d7973686f706966792e636f6d3a31373732353530323232333632.f7acf884f34ea7f92a0c555e323e33c8",
                    },
                },
            );
            const data = await response.json();

            if (data.statusCode !== 200 && !data.data) return null;

            return `${data.data.estimatedDeliveryDate.from.date}|${data.data.estimatedDeliveryDate.to.date}`;
        } catch (error) {
            return null;
        }
    }

    /* ============================================================ */
    /* Helpers                                                      */
    /* ============================================================ */
    setActiveCard(selector, card) {
        this.querySelectorAll(selector).forEach((otherCard) => {
            otherCard.classList.remove("active");
            otherCard.querySelector("[data-hearts-anchor]")?.setAttribute("hidden", "");
        });
        card.classList.add("active");
        card.querySelector("[data-hearts-anchor]")?.removeAttribute("hidden");
    }

    /* Réinitialise l'état et l'affichage à partir d'une étape donnée */
    resetFrom(stepName) {
        const order = ["model", "size", "frequency"];
        const startIndex = order.indexOf(stepName);

        if (startIndex <= order.indexOf("model")) {
            this.state.product = null;
            this.modelGrid.innerHTML = "";
        }
        if (startIndex <= order.indexOf("size")) {
            this.state.variant = null;
            this.state.sizeLabel = null;
            this.state.count = 0;
            this.state.countLabel = null;
            this.state.unitLabel = null;
            this.sizeGrid.innerHTML = "";
            this.sizeInfo.classList.add("hidden");
            this.sizeInfo.classList.remove("flex");
            this.setLocked("size", true);
        }
        this.state.frequency = null;
        this.frequencyList.innerHTML = "";
        this.setLocked("frequency", true);
        this.setLocked("cross-sell", true);
        this.setLocked("recap", true);
        this.subscribeButton.disabled = true;
    }

    setLocked(stepName, locked) {
        const step = this.steps[stepName];
        if (!step) return;

        if (locked) {
            step.setAttribute("data-locked", "");
        } else {
            step.removeAttribute("data-locked");
        }
    }

    scrollToStep(stepName) {
        // this.steps[stepName]?.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    formatMoney(cents) {
        return (cents / 100).toLocaleString("fr-FR", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });
    }

    escape(value) {
        return String(value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    initSliders() {
        if (!window.matchMedia("(min-width: 768px)").matches) return;

        this.sliders = [];
        this.querySelectorAll("[data-cross-sell-slider]").forEach((slider) => {
            const container = slider.closest(".more-product__container");
            const nav = this.querySelector(`[data-cross-sell-nav="${container.id}"]`);

            this.sliders.push(
                new Swiper(slider, {
                    direction: "horizontal",
                    slidesPerView: 3,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    navigation: {
                        nextEl: nav?.querySelector("[data-slider-next]"),
                        prevEl: nav?.querySelector("[data-slider-prev]"),
                    },
                }),
            );
        });
    }
}

customElements.define("subscription-configurator", SubscriptionConfigurator);
